export const numberFormatter = (price, precision = 2) => {
  // Convert the price to a number with two decimal places
  const formattedPrice = parseFloat((price || 0)).toFixed(precision)

  // Add a dot as a thousands separator
  const priceWithSeparator = formattedPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return priceWithSeparator
}
